import React, { Component } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import axios from 'axios';
import _ from 'underscore';
import analyticsContext, { getDistinctId } from '../../components/analytics/Analytics';
import { campaignHttpHeaders, saveCampaignDetailsToLocal } from '../../util/ApiUtil';
import config from '../../config/config';
import REST_API_NAMES from '../../config/restApiNames';

// Sample redirect URL:
// http://localhost:3000/expert-sessions/email/redirect?destination=https://www.smarthomesupport.com/&messageId=08d0b304-a7fc-49e6-b33c-3193dbf017a5

class ShsRedirect extends Component {
  constructor(props) {
    super(props);
    this.clickCountAPI = {
      url: config.REST_URL(REST_API_NAMES.campaignDetails),
      headers: campaignHttpHeaders,
    };
  }

  componentDidMount() {
    const queryData = queryString.parse(this.props.location.search);
    const { destination, messageId } = queryData;

    if (destination && messageId) {
      const getUrl = this.clickCountAPI.url + messageId;
      const getConfig = {
        headers: this.clickCountAPI.headers,
      };

      axios
        .get(getUrl, getConfig)
        .then((response) => {
          saveCampaignDetailsToLocal(response.data);
          // update the distinctId after data is returned
          analyticsContext.withIdentity({ distinctId: getDistinctId() });
          const analyticsPromise = analyticsContext
            .withAdvancedProps({
              destination,
              ...response.data,
            })
            .screenEvent();
          return analyticsPromise;
        })
        .finally(() => {
          this.redirect(destination);
        });
    }
  }

  redirect = (url) => {
    if (_.isFunction(window.location.replace)) {
      window.location.replace(url);
    } else {
      window.location.href = url;
    }
  };

  render() {
    return <div className="ShsRedirectContainer" />;
  }
}

export default withRouter(ShsRedirect);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/ShsRedirect/ShsRedirect.js